import React from "react";
//#region types
import { GraphConstants, IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { IconDefinition } from "models/propTypes/iconPropTypes";
import { ShareOwnerType } from "models/enums/company";
import { OwnershipStructureViewProps } from "models/propTypes/holdingRegisterPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ChartContainer, SubTitleWithIcon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const OwnershipStructureView: React.FC<OwnershipStructureViewProps> = ({ snapshotDate }) => {
  const getNodeIcon = (branchNode: WintSuperkollAPIModel.BranchNode): IconDefinition | undefined => {
    return branchNode.leaf?.nodeType === undefined
      ? undefined
      : branchNode.leaf?.nodeType === ShareOwnerType.Legal
      ? IconDefinitionConstants.WCompany
      : IconDefinitionConstants.WPerson;
  };

  const apiFilter: Omit<WintSuperkollAPIModel.ShareOwnerFilter, keyof WintUtilsWebApi.Filter> = {
    snapShotDate: snapshotDate,
  };

  return (
    <Grid item container className={cssExports.ownershipStructureView}>
      {!snapshotDate && (
        <SubTitleWithIcon
          subTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.LastKnownOwnerStructure)}
          icon={IconDefinitionConstants.WInfoCircleFill}
        ></SubTitleWithIcon>
      )}
      <Grid item container>
        <ChartContainer
          chartAPIKey={GraphConstants.ChartKeys.OwnershipStructureWidget}
          id={"ownership_structure_view_tree"}
          chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Rating)}
          iconHandler={getNodeIcon}
          filter={apiFilter}
        />
      </Grid>
    </Grid>
  );
};

export default OwnershipStructureView;
